module.exports = __webpack_public_path__ + "img/avatar0.ff9aa2fe.png";